export function getInitialStepForPath(savedProgress, activePathName) {
  if (!savedProgress || !activePathName) {
    return 1;
  }

  const currentPath = savedProgress[activePathName];
  return currentPath?.step && currentPath.step > 0 ? currentPath.step : 1;
}
